import React, { forwardRef, Ref } from 'react';

export type SvgLogoProps = {
  /** The width of the svg */
  width?: number | string;
  /** The height of the svg */
  height?: number | string;
  /** Optional <svg> element attributes */
  fill?: string;
  viewBox?: string;
  preserveAspectRatio?: string;
  /** All SVG elements to be nested within the <svg> */
  children?: React.ReactNode;
  /** Optional accessibility props */
  tabIndex?: number;
  title?: string;
  titleId?: string;
};

export const SvgLogo = forwardRef(function SvgLogo(
  { width = 48, height = 48, title, titleId, children, ...props }: SvgLogoProps,
  ref: Ref<any>,
) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      ref={ref}
      width={width}
      height={height}
      aria-labelledby={titleId}
      viewBox={`0 0 ${width} ${height}`}
      {...props}
    >
      {title && <title id={titleId}>{title}</title>}
      {children}
    </svg>
  );
});
